if (!customElements.get('product-slider-thumbnails')) {
  /**
   *  @class
   *  @function ProductSliderThumbnails
   */
  class ProductSliderThumbnails extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', this.setupProductGallery);
    }
    connectedCallback() {
      // Wacht tot DOM volledig geladen is
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.initialize());
      } else {
        // DOM is al geladen, maar wacht even voor zekerheid
        setTimeout(() => this.initialize(), 50);
      }
    }
    initialize() {
      this.product_container = this.closest('.thb-product-detail');
      if (!this.product_container) {
        // Retry als container nog niet beschikbaar is
        setTimeout(() => this.initialize(), 100);
        return;
      }
      
      this.thumbnail_container = this.product_container.querySelector('.product-thumbnail-container');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');
      
      // Zoek naar wrapper voor buttons - probeer verschillende selectors
      this.product_wrapper = this.closest('.product-images-wrapper') || 
                            this.closest('.thb-product-detail') || 
                            document.querySelector('[class*="product-images-wrapper"]') ||
                            this.parentElement;

      // Setup event delegation als backup
      this.setupEventDelegation();

      this.setOptions();
      // Start Slider
      this.init();
    }
    setupEventDelegation() {
      const _this = this;
      // Event delegation op document level voor buttons
      document.addEventListener('click', function(e) {
        if (e.target.closest('.product-slider-nav--prev') && _this.flkty) {
          e.preventDefault();
          e.stopPropagation();
          _this.flkty.previous();
        } else if (e.target.closest('.product-slider-nav--next') && _this.flkty) {
          e.preventDefault();
          e.stopPropagation();
          _this.flkty.next();
        }
      }, { capture: true });
      
      // Touch support
      document.addEventListener('touchend', function(e) {
        if (e.target.closest('.product-slider-nav--prev') && _this.flkty) {
          e.preventDefault();
          e.stopPropagation();
          _this.flkty.previous();
        } else if (e.target.closest('.product-slider-nav--next') && _this.flkty) {
          e.preventDefault();
          e.stopPropagation();
          _this.flkty.next();
        }
      }, { passive: false });
    }
    setOptions() {
      this.hide_variants = this.dataset.hideVariants == 'true';
      this.thumbnails = this.thumbnail_container.querySelectorAll('.product-thumbnail');
      // Zoek naar product-slider-nav buttons - probeer verschillende manieren
      if (!this.product_wrapper) {
        this.product_wrapper = this.closest('.product-images-wrapper') || 
                              this.closest('.thb-product-detail') || 
                              document.querySelector('[class*="product-images-wrapper"]') ||
                              this.parentElement;
      }
      
      // Probeer verschillende selectors voor buttons
      this.prev_button = this.product_wrapper ? this.product_wrapper.querySelector('.product-slider-nav--prev') : null;
      this.next_button = this.product_wrapper ? this.product_wrapper.querySelector('.product-slider-nav--next') : null;
      
      // Als niet gevonden, probeer via document
      if (!this.prev_button || !this.next_button) {
        this.prev_button = document.querySelector('.product-slider-nav--prev');
        this.next_button = document.querySelector('.product-slider-nav--next');
      }
      this.options = {
        wrapAround: true,
        pageDots: false,
        contain: true,
        adaptiveHeight: true,
        initialIndex: '.is-initial-selected',
        prevNextButtons: false,
        fade: false,
        draggable: true,
        cellSelector: '.product-images__slide.is-active'
      };
    }
    init() {
      this.flkty = new Flickity(this, this.options);

      this.selectedIndex = this.flkty.selectedIndex;

      // Setup Events
      this.setupEvents();

      // Start Gallery
      this.setupProductGallery();
    }
    reInit(imageSetIndex) {

      this.flkty.destroy();

      this.setOptions();

      this.flkty = new Flickity(this, this.options);

      // Setup Events
      this.setupEvents();

      this.selectedIndex = this.flkty.selectedIndex;
    }
    setupEvents() {
      const _this = this;
      
      // Setup navigation buttons - zoek buttons in de hele document
      const findButtons = () => {
        const _this = this;
        // Probeer verschillende selectors
        let prevBtn = _this.product_wrapper ? _this.product_wrapper.querySelector('.product-slider-nav--prev') : null;
        let nextBtn = _this.product_wrapper ? _this.product_wrapper.querySelector('.product-slider-nav--next') : null;
        
        if (!prevBtn || !nextBtn) {
          // Probeer via closest parent
          let wrapper = _this.closest('.product-images-wrapper') || 
                       _this.closest('.thb-product-detail') || 
                       _this.parentElement;
          prevBtn = wrapper ? wrapper.querySelector('.product-slider-nav--prev') : null;
          nextBtn = wrapper ? wrapper.querySelector('.product-slider-nav--next') : null;
        }
        
        if (!prevBtn || !nextBtn) {
          // Probeer via document querySelector met wildcard
          let allWrappers = document.querySelectorAll('[class*="product-images-wrapper"]');
          for (let wrapper of allWrappers) {
            prevBtn = wrapper.querySelector('.product-slider-nav--prev');
            nextBtn = wrapper.querySelector('.product-slider-nav--next');
            if (prevBtn && nextBtn) break;
          }
        }
        
        if (!prevBtn || !nextBtn) {
          // Laatste poging: direct document query
          prevBtn = document.querySelector('.product-slider-nav--prev');
          nextBtn = document.querySelector('.product-slider-nav--next');
        }
        
        return { prevBtn, nextBtn };
      };
      
      // Probeer buttons te vinden met retry en MutationObserver
      let buttonAttempts = 0;
      let observer = null;
      
      const setupButtons = () => {
        const { prevBtn, nextBtn } = findButtons();
        
        if (prevBtn && nextBtn && _this.flkty) {
          // Stop observer als buttons gevonden zijn
          if (observer) {
            observer.disconnect();
            observer = null;
          }
          
          _this.prev_button = prevBtn;
          _this.next_button = nextBtn;
          
          // Remove old listeners by cloning
          let newPrev = prevBtn.cloneNode(true);
          prevBtn.parentNode.replaceChild(newPrev, prevBtn);
          _this.prev_button = newPrev;
          
          let newNext = nextBtn.cloneNode(true);
          nextBtn.parentNode.replaceChild(newNext, nextBtn);
          _this.next_button = newNext;
          
          // Setup prev button - gebruik meerdere event types voor betere compatibiliteit
          _this.prev_button.onclick = function(e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            if (_this.flkty) {
              _this.flkty.previous();
            }
            return false;
          };
          _this.prev_button.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            if (_this.flkty) {
              _this.flkty.previous();
            }
          }, { capture: true, once: false });
          _this.prev_button.addEventListener('mousedown', function(e) {
            e.preventDefault();
            e.stopPropagation();
            if (_this.flkty) {
              _this.flkty.previous();
            }
          }, { capture: true });
          _this.prev_button.addEventListener('touchend', function(e) {
            e.preventDefault();
            e.stopPropagation();
            if (_this.flkty) {
              _this.flkty.previous();
            }
          }, { passive: false });
          
          // Setup next button
          _this.next_button.onclick = function(e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            if (_this.flkty) {
              _this.flkty.next();
            }
            return false;
          };
          _this.next_button.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            if (_this.flkty) {
              _this.flkty.next();
            }
          }, { capture: true, once: false });
          _this.next_button.addEventListener('mousedown', function(e) {
            e.preventDefault();
            e.stopPropagation();
            if (_this.flkty) {
              _this.flkty.next();
            }
          }, { capture: true });
          _this.next_button.addEventListener('touchend', function(e) {
            e.preventDefault();
            e.stopPropagation();
            if (_this.flkty) {
              _this.flkty.next();
            }
          }, { passive: false });
          
          // Update button states
          _this.updateButtonStates();
        } else if (buttonAttempts < 20) {
          // Retry na 150ms (max 20 keer = 3 seconden)
          buttonAttempts++;
          setTimeout(setupButtons, 150);
        } else {
          // Als buttons na 20 pogingen nog niet gevonden zijn, gebruik MutationObserver
          if (!observer) {
            observer = new MutationObserver(function(mutations) {
              const { prevBtn, nextBtn } = findButtons();
              if (prevBtn && nextBtn && _this.flkty) {
                setupButtons();
              }
            });
            
            // Observeer de hele document body voor nieuwe elementen
            observer.observe(document.body, {
              childList: true,
              subtree: true
            });
            
            // Timeout na 5 seconden
            setTimeout(() => {
              if (observer) {
                observer.disconnect();
                observer = null;
              }
            }, 5000);
          }
        }
      };
      
      // Start setup
      setupButtons();
      this.video_containers.forEach((container) => {
        container.querySelector('button').addEventListener('click', function () {
          container.setAttribute('hidden', '');
        });
      });
      this.flkty.on('settle', function (index) {
        _this.selectedIndex = index;
        _this.updateButtonStates();
      });
      this.flkty.on('change', (index) => {

        let previous_slide = this.flkty.cells[_this.selectedIndex].element,
          previous_media = previous_slide.querySelector('.product-single__media'),
          active_thumb = null;

        // Zoek de huidige slide
        let current_slide = this.flkty.cells[index] ? this.flkty.cells[index].element : null;
        
        if (current_slide) {
          // Haal media ID op van de huidige slide
          let slide_id = current_slide.id || current_slide.getAttribute('data-media-id');
          let media_id = null;
          
          if (slide_id) {
            // Extract media ID uit "Slide-{section.id}-{media.id}"
            let parts = slide_id.split('-');
            if (parts.length >= 3) {
              media_id = parts.slice(2).join('-'); // Neem alles na de tweede dash
            }
          }
          
          // Zoek de bijbehorende thumbnail via media ID
          if (media_id) {
            active_thumb = Array.from(this.thumbnails).find(thumb => {
              // Thumbnail ID is "Thumb-{section.id}-{media.id}"
              if (thumb.id) {
                let thumb_parts = thumb.id.split('-');
                if (thumb_parts.length >= 3) {
                  let thumb_media_id = thumb_parts.slice(2).join('-');
                  return thumb_media_id === media_id;
                }
              }
              return false;
            });
          }
          
          // Fallback: probeer via index als media ID matching niet werkt
          if (!active_thumb) {
            let active_thumbs = Array.from(this.thumbnails).filter(element => element.classList.contains('is-active'));
            if (index < active_thumbs.length) {
              active_thumb = active_thumbs[index];
            } else if (active_thumbs.length > 0) {
              active_thumb = active_thumbs[0];
            }
          }
        }

        // Verwijder is-initial-selected van alle thumbnails
        this.thumbnails.forEach((item, i) => {
          item.classList.remove('is-initial-selected');
        });
        
        // Voeg is-initial-selected alleen toe aan de thumbnail die overeenkomt met de actieve slide
        if (active_thumb) {
          active_thumb.classList.add('is-initial-selected');
        }

        // Scroll thumbnail into view (voor desktop en mobiel) - verbeterd
        requestAnimationFrame(() => {
          if (!active_thumb || active_thumb.offsetParent === null) {
            return;
          }
          const container = active_thumb.parentElement;
          if (!container) return;
          
          const isMobile = window.innerWidth < 768;
          
          if (isMobile) {
            // Op mobiel: horizontaal scrollen - zorg dat thumbnail volledig zichtbaar is
            const containerRect = container.getBoundingClientRect();
            const thumbRect = active_thumb.getBoundingClientRect();
            const scrollLeft = container.scrollLeft;
            const thumbLeft = active_thumb.offsetLeft;
            const thumbWidth = active_thumb.offsetWidth;
            const containerWidth = container.clientWidth;
            
            // Bereken waar de thumbnail moet scrollen
            let targetScroll = thumbLeft - (containerWidth / 2) + (thumbWidth / 2);
            
            // Zorg dat we niet voorbij het begin/einde scrollen
            targetScroll = Math.max(0, Math.min(targetScroll, container.scrollWidth - containerWidth));
            
            container.scrollTo({
              left: targetScroll,
              top: 0,
              behavior: 'smooth'
            });
          } else {
            // Op desktop: verticaal scrollen - thumbnail in het midden
            const scrollTop = container.scrollTop;
            const thumbTop = active_thumb.offsetTop;
            const thumbHeight = active_thumb.offsetHeight;
            const containerHeight = container.clientHeight;
            
            // Bereken waar de thumbnail moet scrollen om in het midden te zijn
            let targetScroll = thumbTop - (containerHeight / 2) + (thumbHeight / 2);
            
            // Zorg dat we niet voorbij het begin/einde scrollen
            const maxScroll = container.scrollHeight - containerHeight;
            targetScroll = Math.max(0, Math.min(targetScroll, maxScroll));
            
            // Scroll naar de positie
            container.scrollTo({
              left: 0,
              top: targetScroll,
              behavior: 'smooth'
            });
            
            // Voeg een kleine delay toe en controleer of we aan het einde zijn
            setTimeout(() => {
              const currentScroll = container.scrollTop;
              const isAtEnd = currentScroll >= maxScroll - 5; // 5px tolerance
              
              // Voeg een class toe om aan te geven dat we aan het einde zijn
              if (isAtEnd) {
                container.classList.add('is-at-end');
              } else {
                container.classList.remove('is-at-end');
              }
            }, 300);
          }
        });

        // Stop previous video
        if (previous_media.classList.contains('product-single__media-external-video')) {
          if (previous_media.dataset.provider === 'youtube') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              event: "command",
              func: "pauseVideo",
              args: ""
            }), "*");
          } else if (previous_media.dataset.provider === 'vimeo') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              method: "pause"
            }), "*");
          }
          previous_media.querySelector('.product-single__media-external-video--play').removeAttribute('hidden');
        } else if (previous_media.classList.contains('product-single__media-native-video')) {
          previous_media.querySelector('video').pause();
        }

      });


      // Make thumbnails clickable - gebruik alle thumbnails, niet alleen active
      const setupThumbnails = () => {
        let activeThumbs = Array.from(this.thumbnails).filter(el => el.classList.contains('is-active') && el.clientWidth > 0);
        
        if (activeThumbs.length === 0) {
          // Retry als thumbnails nog niet geladen zijn
          setTimeout(setupThumbnails, 100);
          return;
        }
        
        // Map each thumbnail to its slide index
        activeThumbs.forEach((thumbnail, activeIndex) => {
          // Make sure thumbnails are clickable
          thumbnail.style.cursor = 'pointer';
          thumbnail.style.pointerEvents = 'auto';
          
          // Remove old listeners by cloning
          let newThumb = thumbnail.cloneNode(true);
          thumbnail.parentNode.replaceChild(newThumb, thumbnail);
          
          // Use the active index directly (this matches the Flickity slide index)
          newThumb.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            _this.thumbnailClick(newThumb, activeIndex);
          }, { capture: true });
          
          // Touch support
          newThumb.addEventListener('touchend', (e) => {
            e.preventDefault();
            e.stopPropagation();
            _this.thumbnailClick(newThumb, activeIndex);
          }, { passive: false });
          
          // Mousedown support voor betere compatibiliteit
          newThumb.addEventListener('mousedown', (e) => {
            e.preventDefault();
            e.stopPropagation();
            _this.thumbnailClick(newThumb, activeIndex);
          }, { capture: true });
        });
      };
      
      // Start setup met delay
      setTimeout(setupThumbnails, 200);

    }
    updateButtonStates() {
      if (!this.prev_button || !this.next_button) return;
      
      var totalSlides = this.flkty.slides.length;
      
      if (totalSlides <= 1) {
        this.prev_button.classList.add('is-disabled');
        this.next_button.classList.add('is-disabled');
      } else {
        // Bij wrapAround zijn buttons nooit disabled
        this.prev_button.classList.remove('is-disabled');
        this.next_button.classList.remove('is-disabled');
      }
    }
    thumbnailClick(thumbnail, index) {
      if (!this.flkty) return;
      
      // Selecteer alleen de slide in Flickity - de change event handler zal de juiste thumbnail markeren
      // NIET handmatig classes toevoegen, laat Flickity dat doen
      try {
        this.flkty.select(index);
        // De change event handler zal automatisch de juiste thumbnail markeren met is-initial-selected
      } catch (e) {
        console.log('Error selecting slide:', e);
      }
    }
    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }
    selectCell(mediaId) {
      this.flkty.selectCell(mediaId);
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }
      this.setEventListeners();
    }
    buildItems() {
      this.activeImages = Array.from(this.querySelectorAll('.product-images__slide.is-active .product-single__media-image'));

      return this.activeImages.map((item) => {
        let index = [].indexOf.call(item.parentNode.parentNode.children, item.parentNode);

        let activelink = item.querySelector('.product-single__media-zoom');

        activelink.dataset.index = index;
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h
        };
      });
    }
    setEventListeners() {
      this.links = this.querySelectorAll('.product-single__media-zoom');
      this.pswpElement = document.querySelectorAll('.pswp')[0];
      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector('.product-images__slide.is-selected'),
            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };


      this.links.forEach((link => {
        link.addEventListener('click', (e) => this.zoomClick(e, link));
      }));
    }
    zoomClick(e, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== 'undefined') {
        let pswp = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.items, this.pswpOptions);
        pswp.listen('firstUpdate', function () {
          pswp.listen('parseVerticalMargin', function (item) {
            item.vGap = {
              top: 50,
              bottom: 50
            };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }
  }
  customElements.define('product-slider-thumbnails', ProductSliderThumbnails);
}